// frontend/admin-portal/src/components/users/ResetPasswordModal.jsx
import React, { useState } from "react";
import { Modal, Button, Alert, Checkbox, Input } from "@fiberhome/shared-ui";
import { userService } from "../../services/userService";

export default function ResetPasswordModal({ open, user, onClose }) {
  const [generate, setGenerate] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const handleReset = async () => {
    setBusy(true);
    setError("");
    try {
      const res = await userService.resetPassword(user.id, {
        sendTempPassword: generate,
        newPassword: generate ? undefined : newPassword,
      });
      setResult(res.temporaryPassword || "Set to the password you entered.");
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={busy ? undefined : onClose}
      title={`Reset Password: ${user?.fullName}`}
      footer={
        result ? (
          <Button variant="primary" onClick={onClose}>
            Done
          </Button>
        ) : (
          <>
            <Button variant="ghost" onClick={onClose} disabled={busy}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleReset} loading={busy}>
              Reset Password
            </Button>
          </>
        )
      }
    >
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      {!result && (
        <>
          <Alert variant="warning" className="mb-3">
            This will immediately log the user out of all sessions.
          </Alert>

          <label className="fh-checkbox mb-3">
            <input
              type="checkbox"
              checked={generate}
              onChange={(e) => setGenerate(e.target.checked)}
            />
            <span>Auto-generate a temporary password</span>
          </label>

          {!generate && (
            <Input
              type="password"
              label="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              hint="Min 8 chars, one uppercase, one lowercase, one digit"
            />
          )}
        </>
      )}

      {result && (
        <>
          <Alert variant="success" className="mb-3">
            Password has been reset. Share it with the user.
          </Alert>
          <div className="fh-temp-password__box">
            <code>{result}</code>
            <Button
              size="sm"
              variant="outline"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}
